/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';

export default class Dropdown extends Component {
  // passed in
  label = 'Options';

  disabled = false;

  // state
  @tracked
  isOpen = false;

  @action
  toggle() {
    this.toggleProperty('isOpen');
  }

  @action
  close() {
    this.isOpen = false;
  }
}
